import { RightScope } from './../../types';

export abstract class Rights<T extends object = object> {
  /**
   * Array of scopes that the rights refer to.
   */
  protected abstract scopes: RightScope[] | RightScope;
  /**
   * Description of the scopes that the rights refer to.
   */
  protected abstract scopesDescription: string;
  public rights: T = {} as T;

  public can(right: keyof T): boolean {
    if (!(right in this.rights)) throw new Error(`Right "${String(right)}" does not exist.`);

    return this.rights[right] === true;
  }

  public cannot(right: keyof T): boolean {
    if (!(right in this.rights)) throw new Error(`Right "${String(right)}" does not exist.`);

    return this.rights[right] === false;
  }

  public setRights(rights: T): this {
    this.rights = rights;

    return this;
  }

  public setScope(scope: RightScope[], description: string): this {
    this.scopes = scope;
    this.scopesDescription = description;

    return this;
  }

  /**
   *
   * @description
   */
  public getScope(): { scopes: RightScope[]; description: string } {
    return { scopes: Array.isArray(this.scopes) ? this.scopes : [this.scopes], description: this.scopesDescription };
  }
}
